import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';

export const fetchClaimEmailStatus = createProvider(api.fetchClaimEmailStatus).andCatch((error) => {
  if (error instanceof Error && error.name === 'AbortError') {
    console.warn('Fetch claim email status aborted');
  } else {
    console.error('Fetch claim email status was failed:', error);
  }
  throw error;
});
